import { CommonModule } from '@angular/common';
import { Component, input, inject, ChangeDetectionStrategy, signal, effect } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { SecurePipe } from '../../pipes/secure.pipe';
import { DialogHelper } from '../../utilities/helpers/dialog-helper/dialog-helper';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrl: './image-carousel.component.scss',
  imports: [CommonModule, NgbCarouselModule, SecurePipe, SkeletonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ImageCarouselComponent {
  previewImageUrls = input.required<string[]>();
  galleryImageUrls = input.required<string[]>();
  imageLoaded = signal<boolean[]>(Array(0));

  imagePerSlide = 4;
  imageSlider: string[][] = [];

  private dialogHelper: DialogHelper = inject(DialogHelper);
  
  ngOnInit(): void {
    const images = this.previewImageUrls();
    for (let i = 0; i < images.length; i += this.imagePerSlide) {
      this.imageSlider.push(images.slice(i, i + this.imagePerSlide));
    }
  }

  openImageModal(imageUrl: string): void {
    const currentIndex = this.previewImageUrls().indexOf(imageUrl);
    this.dialogHelper.openImageModalDialog(this.galleryImageUrls(), currentIndex);
  }

  onImageLoad(i : number): void {
      this.imageLoaded.update(current => {
          const newArray = [...current];
          newArray[i] = true;
          return newArray;
      });
  }

  onImageError(i : number): void {
      this.imageLoaded.update(current => {
          const newArray = [...current];
          newArray[i] = false;
          return newArray;
      });
  }
}
